import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";

// 設定全域 base URL
axios.defaults.baseURL = "https://greenrichgeam.com/api";

// ✅ 頁面載入時自動補上 Authorization header
const token =
  localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// ✅ 檢查 2 小時無操作自動登出
const lastActivity = localStorage.getItem("lastActivity");
if (lastActivity) {
  const twoHours = 2 * 60 * 60 * 1000;
  if (Date.now() - parseInt(lastActivity) > twoHours) {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("displayName");
    localStorage.removeItem("lastActivity");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("displayName");
  }
}

// ✅ 每次點擊更新最後活動時間
document.addEventListener("click", () => {
  if (localStorage.getItem("jwtToken")) {
    localStorage.setItem("lastActivity", Date.now().toString());
  }
});

// ✅ request 攔截器 - 每次請求自動帶上 Token
axios.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ response 攔截器 - 401 自動跳轉登入
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // 登入本身的 401（帳密錯誤）不當作「權杖過期」處理，
    // 讓錯誤直接丟回 Login.vue 顯示訊息
    const isLoginRequest = error.config?.url?.includes("/login/login");

    if (error.response && error.response.status === 401 && !isLoginRequest) {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("displayName");
      localStorage.removeItem("lastActivity");
      sessionStorage.removeItem("jwtToken");
      sessionStorage.removeItem("displayName");
      window.location.href = "/login";
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

const app = createApp(App);
app.use(router);
app.mount("#app");
